import { Skeleton } from '@/components/ui/skeleton';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { PermissionDenied } from '@/components/ui/permission-denied';
import type { ApiError } from '@/core/api';
import { ProjectBudgetRow } from '../components/ProjectBudgetRow';
import { useProjects } from '../queries';

/** Cross-project budget-vs-actual (hours) — read-only report. */
export function ProjectsBudgetPage() {
  const { data, isPending, isError, error, isFetching } = useProjects({});

  const projects = data?.results ?? [];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Budget vs Actual</h1>
        <p className="text-muted-foreground text-sm">
          Logged hours against each project&rsquo;s budget.
        </p>
      </div>

      {isError ? (
        (error as unknown as ApiError)?.status === 403 ? (
          <PermissionDenied message={(error as unknown as ApiError)?.message} />
        ) : (
          <p className="text-destructive text-sm">
            {(error as unknown as ApiError)?.message ?? 'Failed to load projects.'}
          </p>
        )
      ) : (
        <div className="rounded-md border" aria-busy={isFetching}>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Project</TableHead>
                <TableHead className="text-right">Budget (h)</TableHead>
                <TableHead className="text-right">Actual (h)</TableHead>
                <TableHead className="text-right">Remaining (h)</TableHead>
                <TableHead>Utilization</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {isPending ? (
                Array.from({ length: 4 }).map((_, i) => (
                  <TableRow key={i}>
                    <TableCell colSpan={5}>
                      <Skeleton className="h-6 w-full" />
                    </TableCell>
                  </TableRow>
                ))
              ) : projects.length ? (
                projects.map((p) => <ProjectBudgetRow key={p.id} project={p} />)
              ) : (
                <TableRow>
                  <TableCell colSpan={5} className="text-muted-foreground text-center">
                    No projects yet.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
